import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AdminManageService } from '../../../core/services/adminService/admin-manage.service';
import { UserApiService } from '../../../core/services/user-api.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { CompanyCodeService } from '../../../core/services/adminService/company-code.service';
import { Subscription } from 'rxjs';
import { constantTxt } from '../../../core/constants/constants';

@Component({
  selector: 'app-admin-manage-request',
  templateUrl: './admin-manage-request.component.html',
  styleUrls: ['./admin-manage-request.component.less'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzButtonModule,
    NzSelectModule,
    NzInputModule,
    NzTableModule,
  ],
})
export class AdminManageRequestComponent implements OnInit, OnDestroy {
  searchForm: FormGroup;
  gridData: any[] = [];
  pageSize = 100;
  pageNumber = 1;
  companies: any[] = [];
  buyers: any[] = [];
  purchasingOffices: any[] = [];
  statuses = [
    'ALL',
    'DRAFT',
    'OPEN',
    'IN PROGRESS',
    'PARTIAL QUOTED',
    'CLOSED',
    'CANCELED',
  ];
  attachmentMap: { [key: string]: boolean } = {};
  customNoDataMessage = constantTxt.noDataFound;
  companiesSubscription!: Subscription;
  buyerSubscription!: Subscription;
  officeSubscription!: Subscription;
  searchSubscription!: Subscription;

  constructor(
    private readonly fb: FormBuilder,
    private readonly adminService: AdminManageService,
    private readonly userApi: UserApiService,
    private readonly router: Router,
    private readonly companyCodeService: CompanyCodeService
  ) {
    this.searchForm = this.fb.group({
      companyCode: [''],
      buyer: [''],
      purchasingOffice: [''],
      status: ['DRAFT'],
      pnaNo: ['', [Validators.pattern('^\\d+(?:-\\d+)?$')]],
    });
  }

  ngOnInit() {
    this.loadDropdowns();
    this.onSearch();
  }

  loadDropdowns() {
    this.companiesSubscription = this.companyCodeService
      .getCompanies()
      .subscribe({
        next: (res) => {
          let data = res.body;
          if (data) {
            this.companies = data;
          }
        },
      });

    this.buyerSubscription = this.userApi.getBuyers().subscribe({
      next: (res) => {
        let data = res.body;
        if (data) {
          this.buyers = data;
        }
      },
    });

    this.officeSubscription = this.userApi.getOfficesList().subscribe({
      next: (res) => {
        let data = res.body;
        if (data) {
          this.purchasingOffices = data;
        }
      },
    });
  }

  onSearch() {
    const filters = {
      ...this.searchForm.value,
      status:
        this.searchForm.value.status === 'ALL'
          ? ''
          : this.searchForm.value.status,
    };
    this.searchSubscription = this.adminService
      .searchAdminManage(filters)
      .subscribe({
        next: (res) => {
          let data = res.body;
          if (data) {
            this.gridData = data;
          } else {
            this.gridData = [];
          }
        },
      });
  }

  onPageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
    this.pageNumber = 1;
  }

  onPageIndexChange(pageIndex: number): void {
    this.pageNumber = pageIndex;
  }

  onEditRequest(row: any) {
    const navigationState = {
      mode: 'edit',
      role: 'admin',
      pnaNo: row.pnaNo,
      year: row.pnaYear,
      returnUrl: '/admin/manage-request',
    };

    this.router.navigate(['/admin/edit-request'], {
      state: navigationState,
    });
  }

  ngOnDestroy(): void {
    if (this.companiesSubscription) {
      this.companiesSubscription.unsubscribe();
    }
    if (this.buyerSubscription) {
      this.buyerSubscription.unsubscribe();
    }
    if (this.officeSubscription) {
      this.officeSubscription.unsubscribe();
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}
